import { useEnum, useTable } from '@composables/common'
import { AssetStatus, AssetSubStatus } from '@src/enums'
import PlatformNameCellRenderer from '@src/partials/platforms/PlatformNameCellRenderer.vue'
import router from '@src/router'
import { Asset, TableSorting } from '@src/types'
import { useUserStore } from '@src/utils/stores/user'
import moment from 'moment'
import { Ref, computed, ref, shallowRef } from 'vue'

const { getEnumLabel } = useEnum()

export function usePaymentAccountAssetsTable(assets: Ref<Asset[]>) {
    const userStore = useUserStore()

    const total = computed(() => {
        return assets.value.length
    })

    const { TableWrapper: PaymentAccountAssetsTable } = useTable({
        tableProps: {
            id: 'payment_account_assets',
            label: 'payment_account_assets',
            help: 'help_payment_account_assets_table',
            data: assets,
            total: total,
            sorting: ref<TableSorting[]>([
                {
                    field: 'created_on',
                    direction: 'desc',
                },
            ]),
            columns: [
                {
                    label: 'id',
                    key: 'asset_uid',
                    select: true,
                },
                {
                    label: 'id',
                    key: 'asset_uid',
                    url: assetsTableUrl,
                    sorting: true,
                    condition: userStore.can('see_id_columns'),
                    copy: true,
                },
                {
                    label: 'name',
                    key: 'asset_title',
                    url: assetsTableUrl,
                    sorting: true,
                    copy: true,
                },
                {
                    label: 'platform',
                    key: 'platform_name',
                    cellRenderer: shallowRef(PlatformNameCellRenderer),
                    sorting: true,
                },
                {
                    label: 'status',
                    key: 'status',
                    cellRenderer: (props: { rowData: Asset }) => {
                        return getEnumLabel(
                            AssetStatus,
                            props.rowData.status,
                            true
                        )
                    },
                    sorting: true,
                },
                {
                    label: 'sub_status',
                    key: 'sub_status',
                    cellRenderer: (props: { rowData: Asset }) => {
                        return props.rowData.sub_status !== null
                            ? getEnumLabel(
                                  AssetSubStatus,
                                  props.rowData.sub_status,
                                  true
                              )
                            : '-'
                    },
                    sorting: true,
                },
                {
                    label: 'currency',
                    key: 'currency',
                    sorting: true,
                },

                {
                    label: 'created_on',
                    key: 'created_on',
                    sorting: true,
                    cellRenderer: (props: { rowData: Asset }) => {
                        return moment(props.rowData.created_on).format(
                            'DD.MM.yyyy'
                        )
                    },
                },
            ],
            actions: [
                {
                    action: handleViewAsset,
                    icon: 'fa-eye',
                    title: 'view',
                    condition: userStore.can('view_assets'),
                },
            ],
        },
    })

    function handleViewAsset(asset: Asset) {
        router.push({ name: 'asset', params: { id: asset.asset_uid } })
    }

    function assetsTableUrl(asset: Asset) {
        return '/assets/' + asset.asset_uid
    }

    return {
        PaymentAccountAssetsTable,
    }
}
